/* Créaroma media V14 — 2026-10-26. Matching thumbnails and more breathing room for the official pouch. */
(() => {
  function boot() {
    const root=document.querySelector('[data-cr2-pdp]');
    const gallery=root?.querySelector('[data-cr2-gallery]');
    const stage=gallery?.querySelector('.cr2-gallery-stage');
    const intro=stage?.querySelector('.cr2-gallery-intro');
    const choices=[...(root?.querySelectorAll('[data-cr2-weight-option]')||[])];
    if(!root||!gallery||!stage||!intro||!choices.length||gallery.dataset.v12Ready)return;
    gallery.dataset.v12Ready='true';

    const firstThumbs=gallery.querySelector('.cr2-pdp-thumbs');
    const nativeControls=stage.querySelector('.cr2-gallery-controls');
    const nativePhotoSlides=[...stage.querySelectorAll('.cr2-gallery-photo-slide')];
    const nativeThumbs=[...gallery.querySelectorAll('[data-cr2-gallery-thumb]')];
    const pack300=gallery.querySelector('.cr2-gallery-picture-image');
    const fruitsBg=gallery.dataset.cr2BgFruits||'';
    const freshBg=gallery.dataset.cr2BgFresh||fruitsBg;

    // Aucune des scènes d'ambiance n'embarque de sachet. Le sachet fabricant
    // est l'unique élément produit dans l'assemblage, pour tout poids.
    function newScene(backgroundSrc,packSrc,alt,mode) {
      const node=document.createElement('div');
      node.className='cr2-v12-scene '+(mode==='fresh'?'is-freshness':'is-fruits');
      const bg=document.createElement('div');bg.className='cr2-v12-scene-background';
      if(backgroundSrc)bg.style.backgroundImage='url("'+backgroundSrc.replace(/"/g,'%22')+'")';
      const photo=document.createElement('img');photo.className='cr2-v12-scene-pack';
      photo.loading='lazy';photo.alt=alt;
      if(packSrc)photo.src=packSrc;else photo.hidden=true;
      node.append(bg,photo);
      return node;
    }
    function photoNode(src,alt){
      const image=document.createElement('img');
      image.className='cr2-v12-finished-image';image.loading='lazy';image.src=src;image.alt=alt;
      return image;
    }
    function thumbnailScene(backgroundSrc,packSrc){
      const preview=document.createElement('span');
      preview.className='cr2-v14-thumb-scene';
      const backdrop=document.createElement('span');
      backdrop.className='cr2-v14-thumb-bg';
      backdrop.style.backgroundImage='url("'+backgroundSrc.replace(/"/g,'%22')+'")';
      const pouch=document.createElement('img');
      pouch.className='cr2-v14-thumb-pack';
      pouch.alt='';pouch.loading='lazy';pouch.decoding='async';
      if(packSrc)pouch.src=packSrc;else pouch.hidden=true;
      preview.append(backdrop,pouch);
      return preview;
    }
    function thumb(button,src,alt,background=''){
      if(!button)return;
      button.classList.toggle('cr2-v14-thumb-composite',Boolean(background));
      if(background)button.replaceChildren(thumbnailScene(background,src));
      else{
        const image=document.createElement('img');image.src=src||'';image.alt='';image.loading='lazy';
        if(!src)image.hidden=true;
        button.replaceChildren(image);
      }
      button.setAttribute('aria-label',alt);
    }
    function rebuild300(){
      if(nativePhotoSlides.length<3||nativeThumbs.length<4)return;
      const basePack=pack300?.currentSrc||pack300?.src||'';
      const verifiedOverrides=[
        gallery.dataset.cr2300Fruits||'',
        gallery.dataset.cr2300Fresh||'',
        gallery.dataset.cr2300Sachet||''
      ];
      for(let i=0;i<3;i++){
        const slide=nativePhotoSlides[i];
        const label=[gallery.dataset.cr2SceneOneLabel||'Fruits',gallery.dataset.cr2SceneTwoLabel||'Fraîcheur','Sachet'][i];
        const override=verifiedOverrides[i];
        // Sans nouvelle photographie finale, préserver la photographie Shopify
        // d'origine. Ne jamais construire un sachet sur un arrière-plan.
        const useComposite=gallery.dataset.cr2UseComposite==='true'&&i<2&&!override;
        const bgSource=i===0?fruitsBg:freshBg;
        if(override){
          const photo=photoNode(override,label+' — OstroVit, 300 g');
          // 4:3 lifestyle photos fill the scene; do not crop the final standalone pouch.
          if(i<2){
            slide.classList.add('cr2-v16-landscape-scene');
            photo.classList.add('cr2-v16-full-frame');
          }
          slide.replaceChildren(photo);
        }
        else if(useComposite&&bgSource)slide.replaceChildren(newScene(bgSource,basePack,label+' — OstroVit 300 g',i===0?'fruits':'fresh'));
        const existingImage=slide.querySelector('img');
        thumb(nativeThumbs[i+1],override||(existingImage?.currentSrc||existingImage?.src||basePack),
          'Afficher '+label+' 300 g',useComposite?bgSource:'');
      }
      const fiche300=gallery.dataset.cr2300Fiche||'';
      if(fiche300){
        const cover=photoNode(fiche300,'Pastèque 300 g — informations et sachet');
        cover.classList.add('cr2-v15-300-cover');
        cover.loading='eager';cover.fetchPriority='high';
        intro.appendChild(cover);
        intro.classList.add('cr2-v15-300-cover-active');
      }
      thumb(nativeThumbs[0],fiche300||basePack,'Afficher la fiche du produit 300 g');
    }
    rebuild300();

    // Controls outside the photographic frame, with native Shopify carousel
    // listeners preserved for the 300 g format.
    const rail=document.createElement('div');
    rail.className='cr2-gallery-rail';
    const controlsArea=document.createElement('div');
    controlsArea.className='cr2-v12-controls-area';
    if(firstThumbs){firstThumbs.before(rail);rail.append(controlsArea,firstThumbs);}
    else{stage.after(rail);rail.appendChild(controlsArea);}
    if(nativeControls)controlsArea.appendChild(nativeControls);

    const scene=document.createElement('div');
    scene.className='cr2-v11-variant-scene';scene.hidden=true;scene.setAttribute('role','group');
    scene.setAttribute('aria-label','Photographie du format sélectionné');
    const backdrop=document.createElement('div');backdrop.className='cr2-v11-backdrop';
    const pack=document.createElement('img');pack.className='cr2-v11-pack';pack.loading='lazy';
    const noPhoto=document.createElement('span');noPhoto.className='cr2-v11-no-photo';noPhoto.hidden=true;
    scene.append(backdrop,pack,noPhoto);stage.appendChild(scene);

    const nav=document.createElement('div');nav.className='cr2-v11-variant-nav';nav.hidden=true;
    const prev=document.createElement('button');prev.type='button';prev.textContent='←';prev.setAttribute('aria-label','Image précédente');
    const count=document.createElement('span');count.setAttribute('aria-live','polite');
    const next=document.createElement('button');next.type='button';next.textContent='→';next.setAttribute('aria-label','Image suivante');
    nav.append(prev,count,next);controlsArea.appendChild(nav);
    const thumbs=document.createElement('div');thumbs.className='cr2-v11-variant-thumbs';thumbs.hidden=true;
    thumbs.setAttribute('aria-label','Choisir une photographie du format');
    rail.appendChild(thumbs);
    const frames=['Fiche','Fruits','Fraîcheur','Sachet'];
    let active=0,selected=null,availableFrames=['Fiche','Sachet'];

    const lightbox=document.createElement('dialog');lightbox.className='cr2-v12-lightbox';
    lightbox.setAttribute('aria-label','Agrandir une photographie du produit');
    const full=document.createElement('img');full.alt='';
    const close=document.createElement('button');close.type='button';close.textContent='×';close.setAttribute('aria-label','Fermer');
    close.addEventListener('click',()=>lightbox.close());
    lightbox.addEventListener('click',e=>{if(e.target===lightbox)lightbox.close()});
    lightbox.append(close,full);document.body.appendChild(lightbox);
    function openZoom(){
      if(scene.hidden||pack.hidden||!pack.src||typeof lightbox.showModal!=='function')return;
      full.src=pack.currentSrc||pack.src;full.alt=pack.alt;
      if(!lightbox.open)lightbox.showModal();
    }
    pack.addEventListener('click',openZoom);
    pack.tabIndex=0;pack.setAttribute('role','button');pack.setAttribute('aria-label','Agrandir la photographie');
    pack.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();openZoom()}});
    function finalFor(i){
      const label=availableFrames[i];
      if(label==='Fiche')return selected?.dataset.variantSceneCover||'';
      if(label==='Fruits')return selected?.dataset.variantSceneFruits||'';
      if(label==='Fraîcheur')return selected?.dataset.variantSceneFresh||'';
      if(label==='Sachet')return selected?.dataset.variantSceneSachet||'';
      return '';
    }
    function draw(){
      if(!selected)return;
      const src=selected.dataset.variantImage||'';
      const final=finalFor(active)||'';
      const photoSrc=final||src;
      const isCover=active===0&&Boolean(final);
      intro.hidden=active!==0||isCover;
      scene.hidden=active===0&&!isCover;
      const frameLabel=availableFrames[active]||'';
      const bgSource=frameLabel==='Fruits'?(selected.dataset.variantSceneBgFruits||''):
        (frameLabel==='Fraîcheur'?(selected.dataset.variantSceneBgFresh||''):'');
      const lifestyle=!final&&Boolean(bgSource);
      scene.classList.toggle('is-finished',!!final);
      scene.classList.toggle('is-lifestyle',lifestyle);
      scene.classList.toggle('is-fruits',lifestyle&&frameLabel==='Fruits');
      scene.classList.toggle('is-freshness',lifestyle&&frameLabel==='Fraîcheur');
      backdrop.style.backgroundImage=lifestyle?'url("'+bgSource.replace(/"/g,'%22')+'")':'none';
      pack.hidden=scene.hidden||!photoSrc;
      noPhoto.hidden=Boolean(photoSrc);
      if(active!==0){
        if(photoSrc){pack.src=photoSrc;pack.alt='OstroVit '+(selected.dataset.variantName||'')+' — '+frames[active];}
        else {pack.removeAttribute('src');noPhoto.textContent='Image du format à compléter';}
      }
      count.textContent=(active+1)+' / '+availableFrames.length;
      [...thumbs.children].forEach((node,i)=>node.setAttribute('aria-pressed',String(i===active)));
    }
    function setFrame(i){active=(i+availableFrames.length)%availableFrames.length;draw()}
    prev.addEventListener('click',()=>setFrame(active-1));
    next.addEventListener('click',()=>setFrame(active+1));
    function sync(){
      selected=choices.find(x=>x.getAttribute('aria-pressed')==='true')||choices[0];
      const alternate=selected.dataset.variantName!=='300 g';
      gallery.classList.toggle('cr2-v11-alt-active',alternate);
      if(!alternate){
        // Repart systématiquement de la fiche 300 g, sans l'ancienne vue active.
        if(nativeThumbs[0])nativeThumbs[0].click();
        intro.hidden=false;scene.hidden=true;nav.hidden=true;thumbs.hidden=true;return;
      }
      nav.hidden=false;thumbs.hidden=false;
      availableFrames=['Fiche'];
      const hasPack=Boolean(selected.dataset.variantImage);
      if(hasPack&&(selected.dataset.variantSceneFruits||selected.dataset.variantSceneBgFruits))availableFrames.push('Fruits');
      if(hasPack&&(selected.dataset.variantSceneFresh||selected.dataset.variantSceneBgFresh))availableFrames.push('Fraîcheur');
      if(hasPack)availableFrames.push('Sachet');
      const buttons=[];
      availableFrames.forEach((label,i)=>{
        const button=document.createElement('button');
        button.type='button';button.className='cr2-v11-thumb';
        const sceneLabel=label==='Fruits'?(gallery.dataset.cr2SceneOneLabel||label):
          (label==='Fraîcheur'?(gallery.dataset.cr2SceneTwoLabel||label):label);
        button.setAttribute('aria-label','Afficher '+sceneLabel+' — '+selected.dataset.variantName);
        const photoSrc=finalFor(i)||selected.dataset.variantImage||'';
        const sceneBg=label==='Fruits'?(selected.dataset.variantSceneBgFruits||''):(label==='Fraîcheur'?(selected.dataset.variantSceneBgFresh||''):'');
        const composite=!finalFor(i)&&Boolean(sceneBg);
        if(composite){
          button.classList.add('cr2-v14-thumb-composite');
          button.appendChild(thumbnailScene(sceneBg,selected.dataset.variantImage||''));
        }else{
          const photo=document.createElement('img');photo.alt='';photo.loading='lazy';photo.decoding='async';
          if(photoSrc)photo.src=photoSrc;else photo.hidden=true;
          button.appendChild(photo);
        }
        button.addEventListener('click',()=>setFrame(i));
        buttons.push(button);
      });
      thumbs.replaceChildren(...buttons);setFrame(0);
    }
    // Stop the legacy 300 g key handlers only while viewing other formats.
    gallery.addEventListener('keydown',event=>{
      if(!gallery.classList.contains('cr2-v11-alt-active'))return;
      if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
        event.preventDefault();event.stopImmediatePropagation();
        setFrame(active+(event.key==='ArrowRight'?1:-1));
      }
    },true);
    let startX=null,startY=null;
    stage.addEventListener('touchstart',event=>{
      if(!gallery.classList.contains('cr2-v11-alt-active')||event.touches.length!==1)return;
      startX=event.touches[0].clientX;startY=event.touches[0].clientY;
    },{capture:true,passive:true});
    stage.addEventListener('touchend',event=>{
      if(!gallery.classList.contains('cr2-v11-alt-active')||startX===null)return;
      const touch=event.changedTouches[0];if(!touch){startX=null;return}
      const dx=touch.clientX-startX,dy=touch.clientY-startY;
      event.stopImmediatePropagation();
      if(Math.abs(dx)>42&&Math.abs(dx)>1.3*Math.abs(dy))setFrame(active+(dx<0?1:-1));
      startX=null;startY=null;
    },{capture:true,passive:true});
    choices.forEach(b=>b.addEventListener('click',()=>requestAnimationFrame(sync)));
    root.querySelector('[data-cr2-variant-select]')?.addEventListener('change',()=>requestAnimationFrame(sync));
    requestAnimationFrame(sync);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();